/**
 * Модуль для работы с FAQ (аккордеон)
 */

/**
 * Инициализирует FAQ аккордеон
 * @param {string} itemSelector - Селектор элементов FAQ
 * @param {string} questionSelector - Селектор вопроса
 * @param {string} activeClass - Класс активного элемента
 * @param {boolean} allowMultiple - Разрешить открывать несколько элементов одновременно
 */
export function initFAQ({
  itemSelector = '.faq__item',
  questionSelector = '.faq__question',
  activeClass = 'active',
  allowMultiple = false,
} = {}) {
  const faqItems = document.querySelectorAll(itemSelector)

  if (!faqItems.length) return

  faqItems.forEach((item) => {
    const question = item.querySelector(questionSelector)

    if (!question) return

    question.addEventListener('click', () => {
      const isActive = item.classList.contains(activeClass)

      // Если не разрешено открывать несколько, закрываем все
      if (!allowMultiple) {
        faqItems.forEach((faqItem) => {
          faqItem.classList.remove(activeClass)
        })
      }

      // Если элемент не был активен, открываем его
      if (!isActive) {
        item.classList.add(activeClass)
      } else if (allowMultiple) {
        // Если разрешено несколько, просто закрываем текущий
        item.classList.remove(activeClass)
      }
    })
  })

  // По умолчанию открываем первый вопрос, если не разрешено несколько
  if (!allowMultiple && faqItems[0]) {
    faqItems[0].classList.add(activeClass)
  }
}




